import { AgNumberValueCellEditingWithLoaderRenderer } from 'components/AgGrid/AgNumberValueCellEditingWithLoaderRenderer';
import { RequestStatus } from 'features/request/requestSlice';
import { ProjectStatusEnum } from 'gql/graphql';

import type { ICellRendererParams } from 'ag-grid-community';
import { useCallback } from 'react';

import { useBimSetActKC2OtherCost } from '../hooks/useBimSetActKC2OtherCost';

interface IActsKc2OtherCostAcceptedCellRendererComponent extends ICellRendererParams {
    isEditable: boolean;
    isPlanCost: boolean;
    columnKey: string;
    actKC2OtherId: number;
    onUpdateFinish: (isSuccess: boolean) => void;
    onUpdateStart: () => void;
    statusProject?: ProjectStatusEnum;
}

export const ActsKc2OtherCostCellRendererComponent = (props: IActsKc2OtherCostAcceptedCellRendererComponent) => {
    const { isEditable, statusProject, columnKey, actKC2OtherId, isPlanCost, onUpdateFinish, onUpdateStart, ...rest } =
        props;
    const {
        data: { id: workOrderOtherPriceId, isGroupTitle, isTotalsRow, isExcludedRow },
    } = rest;

    const { bimSetActKC2OtherCostRequest, bimSetActKC2OtherPlanCostStatus } = useBimSetActKC2OtherCost({
        isPlanCost,
        workOrderOtherPriceId,
        actKC2OtherId,
        onUpdateFinish,
        onUpdateStart,
    });

    const onChange = useCallback(
        (value) => {
            bimSetActKC2OtherCostRequest(value ?? 0);
        },
        [bimSetActKC2OtherCostRequest],
    );

    const isProjectStatusDelayed = statusProject === ProjectStatusEnum.Delayed;
    const isShowLoader = bimSetActKC2OtherPlanCostStatus === RequestStatus.FETCHING;

    return !isGroupTitle && !isTotalsRow ? (
        <AgNumberValueCellEditingWithLoaderRenderer
            decimalScale={0}
            isEditable={isEditable}
            idKey="id"
            columnKey={columnKey}
            debounceTime={500}
            onChange={onChange}
            disabled={isProjectStatusDelayed || isExcludedRow}
            isShowLoader={isShowLoader}
            {...rest}
        />
    ) : (
        <span />
    );
};

ActsKc2OtherCostCellRendererComponent.displayName = 'ActsKc2OtherCostAcceptedCellRendererComponent';
